import classNames from 'classnames';

import { Image } from '~components/Image/Image';
import { useBreakpoints } from '~hooks/useBreakpoints';

import styles from './FooterLogo.module.scss';
import type { FooterLogoProps } from './FooterLogo.types';

export function FooterLogo({
  tagName = 'a',
  href,
  logo,
  className,
  logoMobile,
}: FooterLogoProps) {
  const TagName = tagName;
  const [, { isMobile }] = useBreakpoints();
  return (
    <TagName href={href} className={classNames(styles.wrapper, className)}>
      {isMobile && logoMobile ? (
        <Image {...logoMobile} className={styles.logoMobile} />
      ) : (
        <Image {...logo} className={styles.logo} />
      )}
    </TagName>
  );
}
